import { apiSlice } from '@/store/api/apiSlice';
import { getTransitTimestamp } from '@/utils/getTransitTimestamp';

export interface PlanetAspectItem {
  planet: string;
  aspect: number[];
  houseAspect: number[];
  aspectSigns: string[];
}

export const monthlyPlanetAspectsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMonthlyPlanetAspects: builder.query<
      PlanetAspectItem[],
      {
        monthType?: 'current' | 'next';
        timestamp: string;
      }
    >({
      query: ({ timestamp }) => ({
        url: '/transits/general-aspect',
        method: 'GET',
        params: { timestamp },
      }),
    }),
  }),
});

export const { useGetMonthlyPlanetAspectsQuery } =
  monthlyPlanetAspectsApi;
